import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { theme as customTheme, BREAKPOINTS } from '@/styles/themes/default';

import { LiveButton, slideToRight, delayedAnimation } from './shared';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  max-width: 340px;
  min-height: 400px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    max-width: 400px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    max-width: 100%;
  }
`;

const BaseImage = styled.img`
  position: absolute;
  z-index: 1;
  right: 100%;
  height: auto;
  padding: 0 20px;
  top: 45px;
  padding: 0;
  max-width: 310px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    max-width: 330px;
  }
`;

const baseImage2css = css`
  z-index: 2;
  top: 25px;
  margin-right: 20px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin-right: 40px;
  }
`;

const baseImage3css = css`
  z-index: 3;
  top: 0;
  margin-right: 40px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin-right: 80px;
  }
`;

const liveButtonInitialStyles = css`
  position: absolute;
  z-index: 4;
  right: 100%;
  top: 250px;
  background-color: #fff;
  color: ${customTheme.colors.brand.signalRed};

  span {
    background-color: ${customTheme.colors.brand.signalRed};
  }

  :hover {
    background-color: #fff;
    text-decoration: none;
    color: ${customTheme.colors.brand.signalRed};
  }
`;

const Comment = styled.img`
  position: absolute;
  z-index: 4;
  right: 100%;
  max-width: 260px;
  top: 300px;
`;

export const Sessions = () => {
  return (
    <Wrapper>
      <BaseImage css={slideToRight} src="/images/landing/eventExample/session-image-1.png" alt="session example" />
      <BaseImage
        css={[slideToRight, baseImage2css, delayedAnimation(0.7)]}
        src="/images/landing/eventExample/session-image-2.png"
        alt="session example"
      />
      <BaseImage
        css={[slideToRight, baseImage3css, delayedAnimation(1.1)]}
        src="/images/landing/eventExample/session-image-3.png"
        alt="session example"
      />
      <LiveButton css={[slideToRight, liveButtonInitialStyles, delayedAnimation(1.5)]} label="live" />
      <Comment
        css={[slideToRight, delayedAnimation(1)]}
        src="/images/landing/eventExample/session-comment.png"
        alt="session comment example"
      />
    </Wrapper>
  );
};
